import constants from '../constants'

export default {
  loading: false,
  showModalTakeAwayLess: false,
  category_uuid: '',
  categoryList: null,
  attributeList: null,
  attributeFilter: null,
  sub_category_uuid: '',
  coupon_message: '',
  menu_deal: {},
  selectedCategory: null,
  selectedSubCategory: null,
  selectedProduct: null,
  selectedCart: null,
  selectedOrderTime: null,
  selectedOutlet: null,
  selectedHutOutletId: null,
  selectedHutOutlet: null,
  selectedDisposition: null,
  isValidOrderTime: true,
  user: null,
  lang: constants.DEFAULT_LANGUAGE,
  langList: process.env.LANGUAGES.split(','),
  uiDirection: 'ltr',
  warningDisposition: null,
  uuidForNameSeoDuplicate: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js